<template>
  <a-tabs :active-key="activeKey" 
    :tabPosition="tabPosition"
    class="hm-tabs"
    @change="onChange">
    <a-tab-pane v-for="tab in tabs" :key="tab.key" :tab="tab.name">
      <div class="tab-slot">
        <slot :name="`tab-slot-${tab.key}`">
          <div class="hm-slot" :data-slot-name="`tab-slot-${tab.key}`"><div class="sortable-list"></div></div>
        </slot>
      </div>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
export default {
  name: "HmTabs",
  components: {
  },
  props: {
    /**
     * 标签数
     */
    tabNum: {
      type: Number,
      default: 3
    },
    /**
     * 标签名
     */
    tabNames: {
      type: Array,
      default: function() {
        return ['标签一', '标签二', '标签三'];
      } 
    },
    /**
     * 页签位置
     */
    tabPosition: {
      type: String,
      default: 'top'
    }
  },
  data() {
    return {
      activeKey: 0,
      cTabNum: 3,
      cTabNames: ['标签一', '标签二', '标签三']
    }
  },
  watch: {
    tabNum(value) {
      this.cTabNum = value;
    },
    tabNames(value) {
      this.cTabNames = value;
    }
  },
  computed: {
    tabs() {
      let ret = [];
      for(let i=0; i < this.cTabNum; i++) {
        ret.push({
          key: i,
          name: this.cTabNames[i]
        })
      }
      console.log(`tabs: `, ret)
      return ret;
    }
  },
  mounted() {
    this.cTabNum = this.tabNum;
    this.cTabNames = this.tabNames;
  },
  methods: {
    getCssUnit(value) {
      if (isNaN(Number(value))) {
        return value;
      }
      return `${value}px`;
    },
    onChange(value) {
      console.log(`tab change: `, value);
      this.activeKey = value;
      this.$emit('change', value);
    }
  },
};
</script>

<style scoped>
.tab-slot {
  width: 100%;
  min-height: 150px;
  height: 100%;
}

.ant-tabs {
  width: 100%;
}

.tab-slot > .hm-slot {
  width: 100%;
  height: 100%;
}

.tab-slot > .hm-slot:hover {
  background: rgba(253,71,52,.1) !important;
}

.ant-tabs .ant-tabs-top-content {
  height: calc(100% - 45px) !important;
}
</style>